import React, {useEffect, useState, useRef} from 'react';
import styled from 'styled-components';
import { InputFieldDelegate } from './input_fields/inputFieldDelegate';
import { setAndRemoveError } from './input_fields/InputFieldEventHandlers';
import {LoadingIcon} from '../../supplementary_components/loading_icon';
import { sendRequest } from '../../supplementary_components/requests';
import {addNotification} from '../../supplementary_components/store';
import styles from './form.module.scss';
export const Wrapper = styled.div`
    &>div{
        :not(.formContent){
            // padding: 2rem 2rem;
        }
    }
`;
export const Header = styled.div`
    padding: 2rem 2rem;
    background: var(--extra-extra-light-gray);
    box-shadow:  0 0.1rem 0.1rem -0.1rem var(--gray);
    display:flex;
    align-items:center;
    *{
        font-size:1.6rem;
        font-weight:700;
        color: var(--dark-gray);
    }
`;
export const Content = styled.div`
    margin: 0.1rem 0;
    width:42rem;
    max-height:60vh;
    overflow-y: scroll;
    padding: 0 2rem;
`;
export const Footer = styled.div`
    background: var(--extra-extra-light-gray);
    // height:6.5rem;
    padding:2rem;
    box-shadow: 0 -0.1rem 0.1rem -0.1rem var(--gray);
    display:flex;
    align-items:center;
    justify-content:right;
    &>div{
        font-size: 1.15rem;
        font-weight:600;
        // padding: 0.3rem 1rem;
        border-radius:0.4rem;
        box-shadow: var(--button-outline);
        margin-top:1px;
        &:hover{
            cursor:pointer;
        }
    }
    &>div:nth-child(1) {
        padding: 0.3rem 1rem;
        margin-right:1rem;
        color: var(--gray);
    }
    &>div:nth-child(2) {
        
        &.disabled{
            background: rgba(var(--successGreenRGB), 0.4);
        }
        &:not(.disabled){
            background:var(--main-color);
        }
        color:white;
    }
    &>div:nth-child(2)>input {

        background: none;
        color: inherit;
        border: none;
        font: inherit;
        cursor:inherit;
        padding: 0.35rem 1.5rem;
    }
`;
export const SumbitForm = styled.form`
    padding: 1rem 0 3rem 0;
    position:relative;
    
`;
const SwitchToDifferentFormButton = styled.div`
    width:100%;
    margin-top:1.5rem;
    text-align:center;
    // font-weight:500;
    color:var(--main-color);
    cursor:pointer;
    text-decoration:underline;
    text-underline-offset: 0.25rem;
`;

export const Form = ({closePopup, popupData, postSuccessAction}) =>{
    const [loading, setLoading] = useState({state:false, height:'0'});
    const [formConf, setFormConf] = useState(popupData.configuration);
    const hasChangedRef = useRef(formConf.ignoreChangesTracker || false);
    const pageRef = useRef(null);
    if(formConf.customPostSuccessAction){
        // postSuccessAction = setFormConf(formConf.customPostSuccessAction);
        postSuccessAction = formConf.customPostSuccessAction;
    }
    useEffect(
        () => {
            if (pageRef != null){
                if(formConf.customUseEffect){
                    try {
                        formConf.customUseEffect(pageRef);
                    } catch (error) {}
                }
                setLoading({state:false, height:`${pageRef.current.clientHeight}px`})
            } 
            
        }, [pageRef, formConf]
    );
    // Track form changes using event delegation
    useEffect(() => {
        // Reset state when new form loads (only if not forcing ignore)
        
        if (formConf.selectMode || !formConf.name || formConf.ignoreChangesTracker || hasChangedRef.current) return;
        
        const formElement = document.getElementById(formConf.name);
        if (!formElement) return;
        
        // Single event handler for all form inputs
        const handleFormChange = (e) => {
            // Only track actual form field interactions
            const tagName = e.target.tagName;
            if (tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA') {
                // Ignore hidden inputs and submit buttons
                const inputType = e.target.type;
                if (inputType !== 'hidden' && inputType !== 'submit' && inputType !== 'button') {
                    hasChangedRef.current = true;
                    // Remove listeners immediately to stop further processing
                    formElement.removeEventListener('input', handleFormChange);
                    formElement.removeEventListener('change', handleFormChange);
                    formElement.removeEventListener('paste', handleFormChange);
                }
            }
        };
        
        // Use event delegation - one listener handles all inputs
        formElement.addEventListener('input', handleFormChange);
        formElement.addEventListener('change', handleFormChange);
        formElement.addEventListener('paste', handleFormChange);
        
        // Also track DOM structure changes (for added/removed blocks)
        const observer = new MutationObserver((mutations) => {
            // Check if nodes were actually added or removed
            const hasStructuralChanges = mutations.some(mutation => 
                mutation.type === 'childList' && 
                (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
            );
            
            if (hasStructuralChanges) {
                hasChangedRef.current = true;
                
                // PERFORMANCE: Disconnect immediately to stop further processing
                observer.disconnect();
                formElement.removeEventListener('input', handleFormChange);
                formElement.removeEventListener('change', handleFormChange);
                formElement.removeEventListener('paste', handleFormChange);
            }
        });

        observer.observe(formElement, { childList: true, subtree: true });

        return () => {
            formElement.removeEventListener('input', handleFormChange);
            formElement.removeEventListener('change', handleFormChange);
            formElement.removeEventListener('paste', handleFormChange);
            observer.disconnect();
        };
        // eslint-disable-next-line
    }, [formConf.name, formConf.selectMode]); 

    const changeLoadingState = (state) => {
        setLoading({state: state, height: loading.height})
    }
    // let formConf = popupData.configuration;
    
    if (formConf===null)return <Content className="formContent" style={{ height: '10rem'}}><LoadingIcon state={true} height={'10rem'} /></Content>
    const sumbitForm = (event) => {
       
        event.preventDefault();
        // If nothing changed, validate and close without submitting
        if (!hasChangedRef.current) {
            if (checkForEmptyField(formConf, event)) {
                return; // Validation failed
            }
            // Validation passed, close without sending request
            console.log('doNotProceed');
            closePopup();
            return;
        }
        
        // Form has changed, proceed with normal submission
        if (checkForEmptyField(formConf, event)){return;}
        prepareRequestPayload(formConf, event).then(async payload => {
            if (payload !== null){
                
                if(payload.dismissWithCustomMsg){
                    addNotification({message:payload.customMsg, type:'alert'});
                    changeLoadingState(false);
                    
                    return;
                }
                if(payload.dismissRequestWithSuccessMsg){
                    if(formConf.successMessage){
                        addNotification({message:formConf.successMessage,type:'success'});
                    }
                    changeLoadingState(false);
                    closePopup();
                    return;
                }else if(payload.doNotProceed){
                    changeLoadingState(false);
                    return;
                }
                changeLoadingState(true);
                sendRequest(
                    formConf.customMethod?formConf.customMethod:'POST',
                    formConf.addLink,
                    null,
                    (value)=>{
                        if(formConf.successMessage){
                            addNotification({message:formConf.successMessage,type:'success'});
                        }
                        postSuccessAction(value, formConf, setFormConf, payload, event);
                        changeLoadingState(false);
                        if(!formConf.customPostSuccessAction){
                            closePopup();
                        }
                    } ,
                    (e)=>{
                        addNotification({message:e && e.customError?e.customError:`Something went wrong`, type:'alert'});
                        changeLoadingState(false);
                    },
                    payload,
                    formConf.customContentType?formConf.customContentType:null,
                    formConf.preSendManipulation?formConf.preSendManipulation:null,
                );
                
            }else{
                addNotification({message:`Invalid input(s)`, type:'alert'});
                changeLoadingState(false);
            }
        });
    }    
    return <Wrapper ref={pageRef} data-form-root>
        <LoadingIcon state={loading.state} height={loading.height} />
        <Header > <span>{formConf.formTitle}</span></Header>
        <Content className="formContent">
            {
                formConf.selectMode ? 
                <div className={styles.optionsContainer}>
                    {formConf.options.map((option, index) => {
                        return <div key={index} onClick={()=>{
                            if(closePopup()){
                                setTimeout(() => {
                                    option.action()
                                }, 10);
                            }
                        }}>{option.label}</div>
                    })}
                </div>
                :
                <SumbitForm method="POST" autoComplete="off" id={formConf.name} onSubmit={(e)=>{sumbitForm(e)}} >
                    {formConf.columns.map((column, index)=>{
                        return <InputFieldDelegate 
                                index = {index}
                                key={column.name + index}
                                column={column}
                                prefill={popupData.prefill ? index===popupData.prefill.index?popupData.prefill.val : '' : ''}
                            />
                    })}
                    {formConf.switchToDifferentForm ? <SwitchToDifferentFormButton onClick={()=>{formConf.switchingForm(formConf, setFormConf)}} >{formConf.switchToDifferentLabel}</SwitchToDifferentFormButton> : null}
                </SumbitForm>
            }
            
        </Content>
        <Footer data-form-footer>
            <div onClick={()=>{closePopup()}} className="non-selectable">Cancel</div>
            {!formConf.oneButtonMode ? <div> <input type="submit" form={formConf.name} value={formConf.customSubmitButton?formConf.customSubmitButton:formConf.formTitle}/></div> : null }
        </Footer>
    </Wrapper>
}

export const checkForEmptyField = (conf, event) => {
    let scrolledToNeededField = false;
    conf.columns.forEach(column => {
        
        if (column.type === "loadPickupDeliveryStops" || column.type === "chargeOrFeeBlock" || column.type === "driverWeeklyDeductionsEditor"){
            let stopsSection = document.querySelectorAll(column.type === "chargeOrFeeBlock" || column.type === "driverWeeklyDeductionsEditor" ? `#${column.name}Block` :'#newLoadStops');
            if (stopsSection != null){
                for(let form of stopsSection){
                    let previousStopDate = null;
                    // let index = -1;
                    for (const inputTag of form.querySelectorAll('input')){
                        if(inputTag.type === 'checkbox' || inputTag.classList.contains('hiddenField')) continue;
                        
                        let wrongDates = false;
                        if(inputTag.name === "apptDate"){
                            // index += 1;
                            if(previousStopDate){
                                // const thisStopsTime = form.querySelectorAll("input[name='apptTime']")[index].value !== "" ? " " + form.querySelectorAll("input[name='apptTime']")[index].value : "";
                                // const previousStopsTime = form.querySelectorAll("input[name='apptTime']")[index-1].value !== "" ? " " + form.querySelectorAll("input[name='apptTime']")[index-1].value : "";
                                // wrongDates = new Date(previousStopDate + previousStopsTime) > new Date(inputTag.value + thisStopsTime);
                                wrongDates = new Date(previousStopDate) > new Date(inputTag.value);
                            }
                            previousStopDate = inputTag.value
                        }
                        
                        
                        if ((inputTag.getAttribute("data-mandatory") === 'true' && inputTag.value === '') || wrongDates){
                            if (wrongDates){
                                addNotification({message:`Wrong Dates`, type:'alert'});
                            }
                            if(!inputTag.className.includes('subError')){
                                inputTag.classList += 'subError';
                            }
                            if (!scrolledToNeededField){
                                moveToTheLabel(column.name);
                                scrolledToNeededField = true;
                            }
                        }
                    }
                }
                
            }
            
        }else if (column.type === 'dropBox' && column.mandatory){
            const hasFile = column.multiple
                ? Array.isArray(column.files) && column.files.length > 0
                : Boolean(column.file);
            const target = event.target[column.name];
            if (!hasFile) {
                if (!scrolledToNeededField) {
                    moveToTheLabel(column.name);
                    scrolledToNeededField = true;
                }
                if (target) {
                    target.setAttribute('data-empty-error-applied', true);
                    setAndRemoveError(column, target, `This field cannot be empty`, true);
                }
            } else if (target) {
                setAndRemoveError(column, target, `This field cannot be empty`, false);
            }
        }else if (column.mandatory){
            const target = event.target[column.name];
            if(target === undefined){return;}
            if(!target.disabled){
                if (target.value === ''){
                    target.setAttribute('data-empty-error-applied', true);
                    if (!scrolledToNeededField){
                        moveToTheLabel(column.name);
                        scrolledToNeededField = true;
                    }
                    setAndRemoveError(column, target, `This field cannot be empty`, true);
                } else if (target.getAttribute('data-empty-error-applied') === 'true') {
                    setAndRemoveError(column, target, `This field cannot be empty`, false);
                }
            }
            
        }
        
    });
    return scrolledToNeededField;
}
function collectDropBoxFiles(column) {
    if (column?.multiple && Array.isArray(column.files) && column.files.length) {
        return column.files;
    }
    return column?.file ? [column.file] : [];
}

async function prepareRequestPayload(conf, event){
    let data = {};
    let file = null;
    let files = [];
    let WRONG_INPUT = false;
    let doNotProceed = false;
    conf.columns.forEach(column => {
        if (column.type === 'dropBox') {
            const selected = collectDropBoxFiles(column);
            if (selected.length) {
                files = selected;
                file = selected[0];
            }
            return;
        }
        const field = event.target[column.name];
        if(field && field.previousElementSibling && field.previousElementSibling.getAttribute("data-loading") === "true"){
            doNotProceed = true;
        }
        if (field === undefined){
            if(column.type === "loadPickupDeliveryStops"){ /// IF WE ARE ADDING A NEW LOAD 
                
                const loadStopsComponent = event.target.querySelector('#newLoadStops')
                const stops = [];
                const addressElements = ['companyName', 'addressLine1', 'addressLine2', 'city', 'locationType', 'direction', 'locationType', 'postalCode', 'state', "timezone", "latLng"];
                const stopIsoFields = ['checkIn', 'checkOut'];
                for (const stop of loadStopsComponent.childNodes){
                    if(stop.id !== ''){
                        if(stop.id.includes('stop')){
                            const stopData = {'address' : {}}
                            for (let inputField of stop.querySelectorAll('input')){
                                const value = inputField.value === '' ? null : inputField.value.trim();
                                if(addressElements.includes(inputField.name)){
                                    stopData['address'][inputField.name] =  value;
                                } else if (stopIsoFields.includes(inputField.name)){
                                    const raw = inputField.getAttribute('data-raw');
                                    if (raw) stopData[inputField.name] = raw;
                                }else{
                                    stopData[inputField.name] = value;
                                }
                            }
                            for (let selectField of stop.querySelectorAll('select')){
                                stopData[selectField.name] = selectField.value === '' ? null : selectField.value;
                            }
                            
                            stops.push(stopData);
                        }
                    }
                }
                data[column.name] = stops;
            }else if(column.type === "chargeOrFeeBlock" || column.type === "driverWeeklyDeductionsEditor"){
                const inputs = [];
                const parentComponent = event.target.querySelectorAll(`#${column.name}Block`);
                for(let row of parentComponent){
                    const feeOrCharge = {};
                    for (const input of row.querySelectorAll('input')){
                        if(input.name === 'driver'){
                            feeOrCharge[input.name] = JSON.parse(input.getAttribute('data-value'));
                        }else if(input.type === 'checkbox'){
                            feeOrCharge[input.name] = input.checked;
                        }else if(input.getAttribute('data-parse-float') === 'true'){
                            const parsed = parseFloat(input.value.replace(/[^0-9.-]/g, ''));
                            feeOrCharge[input.name] = Number.isNaN(parsed) ? 0 : parsed;
                        }else{
                            feeOrCharge[input.name] = input.name === "amount" ?  input.value.replace('$', '') : input.value;
                        }
                        
                    }
                    for (const input of row.querySelectorAll('select')){
                        feeOrCharge[input.name] = input.value;
                    }
                    inputs.push(column.structureData?.serializeAsObjects ? feeOrCharge : JSON.stringify(feeOrCharge))
                }
                data[column.name] = inputs.length === 0 ? null : inputs;
            }else if(column.type === "selectionList"){
                try {
                    const sectionContainer = document.querySelector(`#${column.name}`)
                    const SelectedOptions = []
                    for(const option of sectionContainer.querySelectorAll('input')){
                        if (option.checked){
                            SelectedOptions.push(JSON.parse(option.getAttribute('data-value')))
                        }
                    }
                    if(!column.nullAllowed && SelectedOptions.length < 1){
                        WRONG_INPUT = true;
                        moveToTheLabel(column.name);
                        setAndRemoveError(column, sectionContainer, `At least one needs to be selected`, true);
                    }else{
                        setAndRemoveError(column, sectionContainer, `At least one needs to be selected`, false);
                        data['accessibleCompanies'] = SelectedOptions;
                    }
                } catch (error) {
                    
                }
                // data["hasAcc"]
                return
            }else if(column.processChanges){
                data = column.processChanges(column, data, event);
                if(data === null){
                    WRONG_INPUT = true;
                }      
            }
        }else{     
                 
            if(column.ignoreAsRegularField)return;
            if(column.customProcessChanges){
                data = column.customProcessChanges(field, data);
                return
            }
            if(column.name.includes('roles')){
                switch (column.label) {
                    case "Dispatch Level":
                        data["roles"] = "ROLE_DISPATCH_"+(event.target[column.name]).value.toUpperCase()+", ";
                        break;
                    case "Safety Level":
                        data["roles"] = data["roles"] + "ROLE_SAFETY_"+(event.target[column.name]).value.toUpperCase()+", ";
                        break;
                    case "Fleet Level":
                         data["roles"] = data["roles"] + "ROLE_FLEET_"+(event.target[column.name]).value.toUpperCase()+", ";
                        break;
                    case "Accounting Level":
                        data["roles"] = data["roles"] + "ROLE_ACCOUNTING_"+(event.target[column.name]).value.toUpperCase();
                        break;
                    default:
                        break;
                }
                return;
            }
            if(!column.mandatory && column.dataValueRequired){
                const target = event.target[column.name];
                if (target.value === ''){
                    data[column.name] = null;
                    return;
                }
            }
            if (column.suggestionsEnabled && !column.doNotCheckDataValue && column.mandatory && field.getAttribute('data-value') === '' && column.customDisplayMode !== 'none' && field.disabled !== true){
                WRONG_INPUT = true;
                moveToTheLabel(column.name);
                return null;
            }
            if (field.classList?.contains('error')){
                WRONG_INPUT = true;
                moveToTheLabel(column.name);
                return null;
            }
            if(field.value === '')field.value=null;
            data[column.name] = (column.processBeforeSending ? column.processBeforeSending(field.value) : column.suggestionsEnabled ? parseDataValue(field) :  field.value);
            
        } 
        if(column.subMenu && !column.ignoredSubMenu){
            const subMenuData = {};
            column.subMenu.columns.forEach(sumColumn => {
                const val = event.target[sumColumn.name].value;
                if(val !== ''){
                    if(sumColumn.processBeforeSending){
                        data[column.subMenu.databaseColumnName] = sumColumn.processBeforeSending(val);
                        return;
                    }else if(sumColumn.isIndependentColumn){
                        data[sumColumn.name] = sumColumn.format ?  sumColumn.format(val) : val;
                    }else{
                        subMenuData[sumColumn.name] =  val;
                    }
                }
            });
            if( Object.keys(subMenuData).length > 0){
                data[column.subMenu.databaseColumnName] = JSON.stringify(subMenuData);
            }else if (!column.subMenu.noNeedToStringify){
                data[column.subMenu.databaseColumnName] = null;
            }
        }       
    })
    if (WRONG_INPUT)return null;
    if(doNotProceed)return {doNotProceed : true};
    try {
        if(conf.customCheckBeforeSending){
            let result = await conf.customCheckBeforeSending(data);
            if(result && result.cancelSubmission){
                return {doNotProceed : true};
            }
        }
    } catch (error) {
    }
    return new Promise((resolve) => {
        if (conf.buildRequestBody){
            resolve(conf.buildRequestBody(data, file, files));
        }else{
            resolve(data);
        }
    });
    
    
}

const parseDataValue = (field)=>{
    return field.getAttribute('data-value') === '' ? null : JSON.parse(field.getAttribute('data-value'))
}
const moveToTheLabel = columnName => {
    document.getElementById(columnName+"Label").scrollIntoView();
}